import * as types from './constants';

// Send Refer Invitation
export const sendReferralInvitationRequest = data => (
  { type: types.SEND_REFERRAL_INVITATION_REQUEST, payload: data }
);

export const sendReferralInvitationDone = data => (
  { type: types.SEND_REFERRAL_INVITATION_DONE, payload: data }
);

export const sendReferralInvitationFailed = errors => (
  { type: types.SEND_REFERRAL_INVITATION_FAILED, payload: errors }
);

export const sendReferralInvitationReset = errors => (
  { type: types.SEND_REFERRAL_INVITATION_RESET, payload: errors }
);